import {Box, Button, Typography} from '@mui/material';
import {CheckCircleOutline} from '@mui/icons-material';
import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Panel} from '../../components/Panel/Panel';
import {useAddAccountContext} from './AddAccountContext';
import useTitle from '../../hooks/useTitle';
import {useAutoForm} from '../../components/AutoForm/useAutoForm';
import {newUTCDate} from '../../utils/newUTCDate';
import {useRequirementsDentistOrBAU} from '../../hooks/useRequirementsDentistOrBAU';

export const AddAccountSetupAccount: React.FC = () => {
  useTitle('Setup account');
  const {resetForm} = useAutoForm();
  const {recommendsGridUrl} = useRequirementsDentistOrBAU();
  const navigate = useNavigate();
  const {accountId} = useParams<{accountId: string}>();
  const {goToStep, onCreateOrUpdateLoading, account, saving} = useAddAccountContext();
  useEffect(() => {
    goToStep('setup');
    resetForm();
  }, []);

  const contactNames: string[] = [];
  const primaryName =
    account?.primaryContact?.simplifiedName || account?.primaryContact?.name;
  const secondaryName =
    account?.secondaryContact?.simplifiedName || account?.secondaryContact?.name;
  if (primaryName) {
    contactNames.push(primaryName);
  }
  if (secondaryName) {
    contactNames.push(secondaryName);
  }
  const message =
    // eslint-disable-next-line no-nested-ternary
    contactNames.length === 1
      ? `Client ${contactNames[0]} has been created!`
      : contactNames.length
      ? `Client ${contactNames[0]} & ${contactNames[1]} has been created!`
      : `Client has been created`;

  // if (done) {
  return (
    <>
      <Panel title="Successfully created">
        <Box
          justifyContent="center"
          display="flex"
          alignItems="center"
          flexDirection="column"
          width="100%"
          mt={2}
          mb={2}
        >
          <CheckCircleOutline height={80} width={80} fontSize="large" htmlColor="green" />
          <Typography variant="h3">{message}</Typography>
          <Typography variant="h6">
            Would you like to proceed to creating an instruction for this client?
          </Typography>
        </Box>
        <Box
          mb={1}
          justifyContent="space-between"
          display="flex"
          alignItems="center"
          width="100%"
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              navigate(`/account/${accountId}/`, {});
            }}
          >
            Exit
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              navigate(`/account/${accountId}/${recommendsGridUrl}`, {});
            }}
          >
            Proceed
          </Button>
        </Box>
      </Panel>
    </>
  );
};
